import { send, configure } from '@rlx/feim'
import { takeEvery, call, select } from 'redux-saga/effects'
import { ON_LOGIN, SET_LOADING, UPDATE_PROGRESS, SET_MUTE, SET_QUICKSPIN,
  ON_PLAY_RESPONSE, PLAY_DONE, SET_BET, UPDATE_WIN, GO_TO_LOBBY, ERROR_CLOSED,
  GameEvents, DISPLAY_HISTORY, ON_SPLASHSTART, SET_HIDE_SPLASH } from '../../redux/constants'
import { RUN_AUTOPLAY, AUTOPLAY_DONE } from '../../components/autoplay/constants'
import { timeUntilExpiration } from '../../Utils'

/**
 * Creates a list of sagas that should be run on specific events.
 */
export default function* watchFetchData() {
  yield takeEvery(ON_LOGIN, onLogin)
  yield takeEvery(SET_LOADING, onLoading)
  yield takeEvery(UPDATE_PROGRESS, onProgress)
  yield takeEvery(ON_PLAY_RESPONSE, onPlayresponse)
  yield takeEvery(PLAY_DONE, onPlayDone)
  yield takeEvery(SET_BET, onSetBet)
  yield takeEvery(UPDATE_WIN, onWin)
  yield takeEvery(SET_MUTE, onMute)
  yield takeEvery(SET_QUICKSPIN, onQuickSpin)
  yield takeEvery(GO_TO_LOBBY, goToLobby)
  yield takeEvery(RUN_AUTOPLAY, send.autoPlayStarted)
  yield takeEvery(AUTOPLAY_DONE, send.autoPlayFinished)
  yield takeEvery(ERROR_CLOSED, onErrorClosed)
  yield takeEvery(DISPLAY_HISTORY, send.showHistory)
  yield takeEvery(ON_SPLASHSTART, onSplashStart)
  yield takeEvery(SET_HIDE_SPLASH, onHideSplash)
  yield takeEvery([ GameEvents.BONUS_STARTED, GameEvents.FREE_SPINS_STARTED ], send.featureStarted)
  yield takeEvery([ GameEvents.BONUS_ENDED, GameEvents.FREE_SPINS_ENDED ], send.featureFinished)
  yield takeEvery(GameEvents.JACKPOT_EVENT_STARTED, jackpotAnimationStarted)
  yield takeEvery(GameEvents.JACKPOT_EVENT_ENDED, jackpotAnimationFinished)
  yield call(initalize)
}

let lastPlayresponse = { }

export function* initalize() {
  const mute = yield select(state => state.base.muted)

  yield onMute({ mute })
}

function* onLogin(action) {
  const { response: loginResponse } = action

  lastPlayresponse = loginResponse.refresh

  configure({
    loginResponse
  })
}

function onLoading(action) {
  if (action.loading) {
    send.gameLoadStarted()
  } else {
    send.gameLoadCompleted()
  }
}

function* onProgress() {
  const { assetProgress } = yield select(state => state.base)

  let progress = 0

  const keys = Object.keys(assetProgress)
  keys.forEach(key => {
    progress += (assetProgress[key] / keys.length)
  })

  send.gameLoadProgress(progress)
}

function* onPlayresponse(action) {
  const { response } = action

  if (!response || !response.stats || response.errorCode) { return }

  lastPlayresponse = response

  const { visibleBalance } = yield select(state => state.session)

  send.roundStarted({ playResponse: response, balance: visibleBalance })
}

function* onPlayDone(action) {
  const { finishedResponse } = action
  const { balance = 0, response = {} } = yield select(state => ({
    balance: state.session.balance,
    response: state.base.response
  }))

  const win = isNaN(response.win) ? 0 : response.win

  send.roundFinished({ balance, win, playResponse: lastPlayresponse, finishedResponse })
}

function onSetBet(action) {
  const { betAmount } = action.payload

  send.betUpdate(betAmount)
}

function onWin(action) {
  const { win } = action

  send.winUpdate({ win })
}

function onMute(action) {
  send.updateSettings({ sounds: !action.mute })
}

function onQuickSpin(action) {
  send.updateSettings({ fastPlay: action.quickSpin })
}

export function* goToLobby() {
  send.exitGame()
}

function* onErrorClosed(action) {
  const { error } = action
  if (error) {
    switch (error.errorCode) {
      case 506: { // Not enough funds
        send.openQuickDeposit()
        break
      }
      default: {
        break
      }
    }
  }
}

function* onSplashStart() {
  send.reportUIState({ splashScreenVisible: true })
}

function* onHideSplash() {
  send.reportUIState({ splashScreenVisible: false })
}

function* jackpotAnimationStarted() {
  //No longer required, but could be used in future
}

function* jackpotAnimationFinished() {
  send.jackpotResolved()
}